import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {WINDOW, HAS_TOUCH, IS_MOBILE, DOCUMENT} from '../../constants/environment';
import Cta from '../cta';
import './styles.css';

/**
 *  CTANavigation
 */
class CTANavigation extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    interaction: PropTypes.bool,
    items: PropTypes.array
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    interaction: true,
    items: [],
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      open: false,
      hasTouch: false,
      bottom: 0
    };
    this.touch = {
      startX: 100,
      startY: null,
      moveX: null,
      moveY: null
    };
    this.flg = true;

  }
  componentDidMount() {
    if (this.props.invisible) return;
    this.init();
  }

  init = (e) => {
    if(HAS_TOUCH){
      this.setState({
        hasTouch: true
      });
    }
    if(HAS_TOUCH && IS_MOBILE){
      setTimeout(()=> {

        // EPIServerのプレビュー時のモーダルの位置調整
        let isEpiServerPreview = false;
        if (WINDOW && WINDOW.epi && WINDOW.parent) {
          const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
          if (wrapperElement) {
            isEpiServerPreview = true;
            setInterval(()=> {
              this.onScrollEpiPreview();
            }, 200)
            setTimeout(()=> {
              if (this.flg) {
                this.flg = false;
                this.setState({
                  open: false
                });
              }
            }, 3000)
          }
        }
        if (!isEpiServerPreview) {
          WINDOW.addEventListener('scroll', this.onScroll);
        }

      }, 1000);
    } else {
      if (this.props.interaction === true) {
        setTimeout(()=> {
          this.setState({
            open: true
          });
          WINDOW.addEventListener('scroll', this.onScrollTemporaryCheck);
        }, 1000);
      }

      // EPIServerのプレビュー時のモーダルの位置調整
      if (WINDOW && WINDOW.epi && WINDOW.parent) {
        const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
        if (wrapperElement) {
          setInterval(()=> {
            this.onScrollTemporaryCheckEpiPreview();
          }, 200)
          setTimeout(()=> {
            if (this.flg) {
              this.flg = false;
              this.setState({
                open: false
              });
            }
          }, 3000)
        }
      }

    }
  };

  onScrollTemporaryCheck = (e)=> {
    if (this.props.interaction !== true) return;
    WINDOW.removeEventListener('scroll', this.onScrollTemporaryCheck);
    if(this.state.open){
      this.setState({
        open: false
      });
    }
  };

  // EPIServerのプレビュー時のモーダルの位置調整
  onScrollTemporaryCheckEpiPreview = (e)=> {
    const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
    if (wrapperElement) {
      const wrapperHeight = wrapperElement.clientHeight;
      const wrapperScrollTop = wrapperElement.scrollTop;
      //
      const bottom = (()=> {
        if (IS_MOBILE) {
          return DOCUMENT.body.clientHeight - (wrapperScrollTop + wrapperHeight);
        } else {
          return DOCUMENT.body.clientHeight - ((wrapperScrollTop + wrapperHeight) - 100);
        }
      })()
      this.setState({
        bottom: bottom,
      })
    }
  };

  onMouseOver = (e) => {
    if(HAS_TOUCH){
      return false;
    }
    if(!this.state.open){
      this.setState({
        open: true
      });
    }
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  onMouseOut = (e) => {
    if(HAS_TOUCH){
      return false;
    }
    if(this.state.open){
      this.setState({
        open: false
      });
    }
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  onClickHandle = (e) => {
    if(this.state.open){
      this.setState({
        open: false
      });
    }
    else if(!this.state.open){
      this.setState({
        open: true
      });
    }
  };

  onScroll = () => {
    if (this.flg) {
      this.flg = false;
      this.setState({
        open: false
      });
    }
    const element = document.getElementsByClassName('SocialIconsContainerBlock')[0];
    if (element) {
      const rect = element.getBoundingClientRect();
      const elementTop = rect.top + window.pageYOffset;
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      if (elementTop <= windowHeight + scrollTop) {
        if(this.state.open) {
          this.setState({
            open: false
          });
        }
      } else {
        if(!this.state.open) {
          this.setState({
            open: true
          });
        }
      }
    }
  };

  // EPIServerのプレビュー時のモーダルの位置調整
  onScrollEpiPreview = ()=> {
    const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
    if (wrapperElement) {
      const wrapperHeight = wrapperElement.clientHeight;
      const wrapperScrollTop = wrapperElement.scrollTop;
      //
      if (this.flg) {
        this.flg = false;
        this.setState({
          open: false
        });
      }
      const element = document.getElementsByClassName('SocialIconsContainerBlock')[0];
      if (element) {
        const rect = element.getBoundingClientRect();
        const elementTop = rect.top + wrapperScrollTop;
        if (elementTop <= windowHeight + wrapperScrollTop) {
          if(this.state.open) {
            this.setState({
              open: false
            });
          }
        } else {
          if(!this.state.open) {
            this.setState({
              open: true
            });
          }
        }
      }
      //
      const bottom = (()=> {
        if (IS_MOBILE) {
          return DOCUMENT.body.clientHeight - (wrapperScrollTop + wrapperHeight);
        } else {
          return DOCUMENT.body.clientHeight - ((wrapperScrollTop + wrapperHeight) - 100);
        }
      })()
      this.setState({
        bottom: bottom,
      })
    }
  }

  render() {
    const {
      containerId,
      containerClass,
      items
    } = this.props;

    if (this.props.invisible) return null;

    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div
          className={
            'CTANavigation' +
            (this.state.open ? ' open' : '') +
            (IS_MOBILE ? ' isMobile' : ' isPc')
          }
          style={(()=> {
            if (WINDOW && WINDOW.epi && WINDOW.parent) {
              const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
              if (wrapperElement) {
                const wrapperWidth = wrapperElement.clientWidth;
                if (wrapperWidth < 768) {
                  return {
                    display: 'none',
                  }
                }
                return {
                  position: 'fixed',
                  bottom: this.state.bottom,
                }
              }
            }
            return null;
          })()}
          // style={(WINDOW && WINDOW.epi && WINDOW.parent) ? {position: 'fixed', bottom: this.state.bottom} : null}
        >
          <div
            className={
              'CTANavigation__container' +
              (this.state.open ? ' open' : '') +
              (this.state.hasTouch ? ' hasTouch' : '')
            }
            onMouseOver={this.onMouseOver}
            onMouseOut={this.onMouseOut}
            ref='container'
          >
            <div className='CTANavigation__container__wrap' style={{paddingBottom: 'calc(env(safe-area-inset-bottom))'}}>
              <ul className='CTANavigation__container__wrap__list'>
                {items.map((item, index) => {
                  item.props.buttonLength = items.length;
                  return(
                    <li className='CTANavigation__container__wrap__list__item' key={index}>
                      <Cta
                        {...item.props}
                      />
                    </li>
                  )
                })}
              </ul>
              <div className='CTANavigation__container__wrap__handle' onClick={this.onClickHandle}></div>
            </div>
          </div>
        </div>
      </Wrapper>
    )
  }

}
export default CTANavigation;



// WEBPACK FOOTER //
// ./src/containers/cta-navigation/index.jsx